/**
 * Sets up the user-specific data for walkme to consume.
 * The "boot up" script can be found in the config
 * The loading of the script can be found in the TrackingLoader component
 * @param user
 */
function configureWalkme(user) {
    window.walkme = {
        userAge: user.UserAge,
        email: user.Email,
        fullName: `${user.FirstName} ${user.LastName}`,
        privilegeAdmin: user.UserPermissions.BranchAdmin || user.UserPermissions.CompanyAdmin,
        privilegeAssignment: user.UserPermissions.WorkQueueAssignment,
        privilegeProtocol: user.UserPermissions.EditProtocols,
        privilegeReports: user.UserPermissions.ReportBuilder || user.UserPermissions.ReportViewer,
        companyName: user.CompanyName,
    };
}

/**
 * Configures the Dynatrace user identification.
 * @param userId
 */
function configureDynatraceUser(userId) {
    if (!userId || typeof window === 'undefined') {
        return () => {};
    }

    // Skip retries in environments where Dynatrace is intentionally not loaded.
    if (!document.getElementById('dynatrace-script')) {
        return () => {};
    }

    let attempts = 0;
    const maxAttempts = 20;
    const retryIntervalMs = 500;

    const identify = () => {
        const identifyUser = window?.dtrum?.identifyUser;
        if (typeof identifyUser === 'function') {
            identifyUser(String(userId));
            return true;
        }

        attempts += 1;
        return attempts >= maxAttempts;
    };

    if (identify()) {
        return () => {};
    }

    const intervalId = window.setInterval(() => {
        if (identify()) {
            window.clearInterval(intervalId);
        }
    }, retryIntervalMs);

    return () => {
        window.clearInterval(intervalId);
    };
}

export { configureDynatraceUser, configureWalkme };
